<template>
  <div class="mob-tabs">
    <div class="tabs-header" v-if="tabs.length > 1">
      <div
        v-for="tab in tabs"
        :key="tab.content"
        :class="['tab no-pointer', { active: activeTab === tab.content }]"
      >
        {{ tab.label }}
      </div>
    </div>
    <div class="tabs-content">
      <div :class="{ 'tabs-wrapper': innerContainer }">
        <slot :name="activeTab"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobTabs",
  data() {
    return {
      activeTab: "",
    };
  },
  props: {
    tabs: {
      type: Array,
      required: true,
      default: () => [],
    },
    activeTabProp: String,
    innerContainer: Boolean,
  },
  watch: {
    activeTab: {
      immediate: false,
      async handler(newVal) {
        if ('MathJax' in window) {
          this.$nextTick(function () {
            window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
          });
        }

      },
    },
  },
  methods: {
    selectTab(tab) {
      this.activeTab = tab.content;
      this.$emit("tabChanged", this.activeTab);
    },
    gotToLessonTab() {
      this.activeTab = 'lesson'
    },
    gotToFinalTab() {
      this.activeTab = 'finalPractice'
    }
  },
  mounted() {
    if (this.tabs[0].content) {
      this.activeTab = this.tabs[0].content;
    }
  },
};
</script>

<style>
/* Estilos del componente aquí */
.mob-tabs {
  @apply flex flex-col w-full;
}

.tabs-header {
  @apply flex border-b border-gray-300 px-4 overflow-x-auto;
}

.tab {
  @apply flex-shrink-0 px-4 py-2 cursor-pointer transition ease-in-out duration-200 text-neutral-500;
}

.tab.no-pointer {
  @apply flex-shrink-0 px-4 py-2 transition ease-in-out duration-200 text-neutral-500;
  cursor: default;
}

.tab:hover {
  @apply text-neutral-700;
}

.tab.active {
  @apply border-blue-600 text-blue-600;
  box-shadow: 0px -1px 0px inset #0078ff, 0px 1px 0px #0078ff;
}

.tabs-content {
  @apply w-full p-4 rounded-b-lg;
}

.tabs-wrapper {
  @apply bg-gray-100 rounded-lg p-3;
}
</style>
